import { useQuery } from '@tanstack/react-query';
import { GetBillsEntity, UserWalletServicesService } from 'services/openapi';

import { ElectricQueryKeys } from './constants';

type GetElectricBillsQuery = {
  customerCodes: string;
};

export const useGetElectricBillsListExportQuery = (
  variables: GetElectricBillsQuery,
) => {
  const queryKey = [ElectricQueryKeys.GET_ELECTRIC_BILLS, variables];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetBillsEntity, Error>({
    queryKey: ['export', ...queryKey],
    queryFn: () =>
      UserWalletServicesService.servicesControllerGetOrders(
        variables.customerCodes,
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: false,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data: data,
    isError,
    queryKey: ['export', ...queryKey],
    refetch,
  };
};
